import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/** One normalized error-log entry across all sources (CAPI sends, BQ-sync …). */
export interface ErrorLogEntry {
  /** Which subsystem produced the error. */
  source: "capi" | "bq_sync";
  projectId: number;
  projectName: string | null;
  /** Ad platform for CAPI ('meta'|'google'|'linkedin'), 'bigquery' for bq-sync. */
  platform: string;
  eventType: string | null;
  eventId: string | null;
  /** HTTP status of the failed call (CAPI only). */
  status: number | null;
  /** Short error message / code. */
  message: string | null;
  /** Platform response body excerpt (CAPI only) — the actionable detail. */
  detail: string | null;
  occurredAt: string;
}

export interface LogsFilters {
  /** Restrict to one project. */
  project?: number | null;
  /** Restrict to one ad platform ('meta'|'google'|'linkedin'|'bigquery'). */
  platform?: string | null;
  /** Restrict to one source ('capi'|'bq_sync'). */
  source?: string | null;
}

export function useErrorLogs(filters: LogsFilters = {}) {
  return useQuery<{ items: ErrorLogEntry[] }>({
    queryKey: ["admin", "logs", filters],
    queryFn: () => {
      const p = new URLSearchParams();
      if (filters.project != null) p.set("project", String(filters.project));
      if (filters.platform) p.set("platform", filters.platform);
      if (filters.source) p.set("source", filters.source);
      const qs = p.toString();
      return api(`/admin/logs${qs ? `?${qs}` : ""}`);
    },
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
}
